module.exports = __webpack_public_path__ + "static/img/1.1feedcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zncq/1.png
// module id = 4udm
// module chunks = 1